import { create } from "zustand";
import { InterfaceChaseItem } from "../types/chase-item-types";
import { DriverInterface } from "../types/driver-type";

export interface DriverResponseInterface extends DriverInterface {
  chaseItem: InterfaceChaseItem[];
}

interface IdefaultValues {
  id: number | string;
  data: Record<string, any>;
}

const defaultValues = {
  id: "",
  data: {},
};

interface IuseProviderEditModel {
  onOpen: ({ id, data }: IdefaultValues) => void;
  onClose: () => void;
  initialValues: IdefaultValues;
}

export const useProviderEditModel = create<IuseProviderEditModel>((set) => ({
  initialValues: defaultValues,
  onOpen: ({ id, data }: IdefaultValues) =>
    set({
      initialValues: { id, data },
    }),
  onClose: () =>
    set({
      initialValues: { ...defaultValues },
    }),
}));
